const SortRowColumn = {
    id: 'sort-row',
    disableResizing: true,
    disableExport: true,
    disableGlobalFilter: true,
    disableHideColumn: true,
    disableSortBy: true,
    disableGroupBy: true,
    isSortRowColumn: true,
    sticky: true,
    stickyPosition: 'left',
    width: 48
};
function useInsertSortRowColumn(hooks) {
    hooks.visibleColumns.push((columns, meta) => {
        if (meta.instance.enableRowSort) {
            return [SortRowColumn, ...columns];
        }
        return columns;
    });
}

export { SortRowColumn, useInsertSortRowColumn };
//# sourceMappingURL=useInsertSortRowColumn.esm.js.map
